import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/chameleon-magnifying-glass.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-52256ec3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "user-profile container maxWidth-md text-big"
}
const _hoisted_2 = { class: "header row" }
const _hoisted_3 = { class: "col-sm-2" }
const _hoisted_4 = { class: "col-sm-10" }
const _hoisted_5 = { "data-test": "title" }
const _hoisted_6 = {
  class: "leader-type-desc",
  "data-test": "leader-type-description"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "no-solo-container"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "chameleon with a magnifying glass"
  })
], -1))
const _hoisted_10 = {
  class: "text-center no-solo-message",
  "data-test": "no-solo-message"
}
const _hoisted_11 = {
  key: 1,
  class: "tile-container"
}
const _hoisted_12 = { class: "tile solo-tile" }
const _hoisted_13 = { class: "tile viewpoints-tile" }
const _hoisted_14 = {
  key: 0,
  "data-test": "no-viewpoints-message"
}
const _hoisted_15 = { class: "tile" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_17 = {
  key: 2,
  class: "develop-section row",
  "data-test": "develop-container"
}
const _hoisted_18 = { "data-test": "develop-title" }
const _hoisted_19 = { "data-test": "develop-definition" }
const _hoisted_20 = { class: "strength-item-image" }
const _hoisted_21 = ["src", "alt"]

import { computed, ref } from "vue";
import { debug as d } from "debug";
import { useAxios } from "../composables/api";
import DashboardPanel from "../components/dashboard-panel.vue";
import HeadFromModel from "../components/head/head-from-model.vue";
import StrengthsAndGapsList from "../components/strengths-and-gaps-list.vue";
import leaderTypeColours from "../services/utilities/leadertype-colours";
import LoadingPage from "./loading-page.vue";
import { UserProfileApiModel, DevelopStrengthProgressApiModel } from "../api-models";
import cms from "../services/cms/cms";
import { CmsStrengthItem } from "../services/cms/cms-type-definitions";


export default /*#__PURE__*/_defineComponent({
  __name: 'user-profile',
  props: {
    id: {}
  },
  setup(__props: any) {

const debug = d("cs.MyProfile");

const props = __props;

// Data getters
const { data: user } = useAxios<UserProfileApiModel>(`/api/UserProfile/${props.id}`);
const strengthItems = ref<CmsStrengthItem[]>();
cms.getStrengthItems().then((response) => {
  strengthItems.value = response;
});

// Refs
const isSoloDiamondLoaded = ref(false);
const isViewpointsDiamondLoaded = ref(false);
const hasViewpointsReport = ref<boolean | null>(null);

// Getters
const isDataLoaded = computed(() => !!user.value && !!strengthItems.value);

const hasSoloReport = computed(() => !!user.value?.strengthRatings);

const name = computed(() => `${user.value?.firstName} ${user.value?.lastName}`);

const currentDevelopPlan = computed<DevelopStrengthProgressApiModel | undefined>(
  () => user.value?.developProgress?.currentStrengthProgress,
);

const userExistsAndHasLeaderTypes = computed(
  () =>
    !!user.value && !!user.value.bestFitLeaderTypes && user.value.bestFitLeaderTypes.length === 2,
);

const linearGradient = computed(() => {
  if (!userExistsAndHasLeaderTypes.value) return "#404040";
  const primaryColour = leaderTypeColours[user.value!.bestFitLeaderTypes[0]];
  const secondaryColour = leaderTypeColours[user.value!.bestFitLeaderTypes[1]];
  return `linear-gradient(135deg, ${primaryColour}, ${primaryColour} 50%, ${secondaryColour} 50%)`;
});

const headerBorderColour = computed(() => {
  if (!userExistsAndHasLeaderTypes.value) return "#404040";
  return leaderTypeColours[user.value!.bestFitLeaderTypes[0]];
});

const leaderTypeDesc = computed(() => {
  if (!userExistsAndHasLeaderTypes.value) return "";
  return `${user.value!.bestFitLeaderTypes[0]} & ${user.value!.bestFitLeaderTypes[1]}`.replace(
    /\w\S*/g,
    (s) => s.charAt(0).toUpperCase() + s.substring(1),
  );
});

const strengthData = computed<CmsStrengthItem | undefined>(
  () =>
    strengthItems.value?.filter((strength) => {
      return (
        strength.data.strength_item_id ===
        user.value?.developProgress?.currentStrengthProgress.strengthItemId
      );
    })[0],
);

// Functions
function soloDiamondLoaded(hasData: boolean): void {
  debug("soloDiamondLoaded", hasData);
  isSoloDiamondLoaded.value = true;
}

function viewpointsDiamondLoaded(hasData: boolean): void {
  debug("viewpointsDiamondLoaded", hasData);
  isViewpointsDiamondLoaded.value = true;
  hasViewpointsReport.value = hasData;
}

return (_ctx: any,_cache: any) => {
  return (isDataLoaded.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "leader-type-circle",
              style: _normalizeStyle(`background: ${linearGradient.value}`),
              "data-test": "leader-types-circle"
            }, null, 4)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("h1", _hoisted_5, _toDisplayString(name.value) + "'s Profile", 1),
              _createElementVNode("hr", {
                class: "hr-magazine-thick hr-magazine-left hr-magazine-short",
                style: _normalizeStyle(`border-color: ${headerBorderColour.value}`)
              }, null, 4),
              _createElementVNode("p", _hoisted_6, _toDisplayString(leaderTypeDesc.value), 1)
            ])
          ])
        ]),
        _hoisted_7,
        (!hasSoloReport.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("h3", _hoisted_10, " Oops! Nothing to see here! Once " + _toDisplayString(_unref(user).firstName) + " has completed their Solo report, we'll display it here. ", 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(user) && hasSoloReport.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(DashboardPanel, {
                  href: `/soloreport/view/${_unref(user).soloReportId}`,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  title: "Solo",
                  "tooltip-text": `The Solo report shows ${_unref(user).firstName}'s view of themselves.`,
                  "is-clickable": "true",
                  "data-test": "solo-panel"
                }, {
                  default: _withCtx(() => [
                    (!isSoloDiamondLoaded.value || hasSoloReport.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass([{ hidden: !isSoloDiamondLoaded.value || !hasSoloReport.value }, "panel-head-container"])
                        }, [
                          _createVNode(HeadFromModel, {
                            animateEntrance: true,
                            headId: _ctx.id,
                            kind: "solo",
                            onOnDataLoaded: soloDiamondLoaded,
                            "data-test": "solo-head"
                          }, null, 8, ["headId"])
                        ], 2))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["href", "tooltip-text"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(DashboardPanel, {
                  title: "Viewpoints",
                  href: `/viewpoints/view/${_ctx.id}`,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "tooltip-text": `The Viewpoints report shows all ${_unref(user).firstName}'s viewpoints feedback aggregated together. This is how others view ${_unref(user).firstName}.`,
                  "is-clickable": isViewpointsDiamondLoaded.value && hasViewpointsReport.value,
                  "data-test": "viewpoints-panel"
                }, {
                  default: _withCtx(() => [
                    (isViewpointsDiamondLoaded.value && !hasViewpointsReport.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_unref(user).firstName) + " hasn't yet received enough Viewpoints ", 1))
                      : (!isViewpointsDiamondLoaded.value || hasViewpointsReport.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass([{ hidden: !isViewpointsDiamondLoaded.value || !hasViewpointsReport.value }, "panel-head-container"])
                          }, [
                            _createVNode(HeadFromModel, {
                              animateEntrance: true,
                              headId: _ctx.id,
                              kind: "viewpoints",
                              onOnDataLoaded: viewpointsDiamondLoaded,
                              "data-test": "viewpoints-head"
                            }, null, 8, ["headId"])
                          ], 2))
                        : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["href", "tooltip-text", "is-clickable"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(DashboardPanel, {
                  href: `/soloreport/view/${_unref(user).soloReportId}`,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  title: "Solo ratings",
                  "tooltip-text": `This shows ${_unref(user).firstName}'s top strengths, and gaps from their solo report.`,
                  "is-clickable": "true",
                  "data-test": "solo-strengths-and-gaps-panel"
                }, {
                  default: _withCtx(() => [
                    (hasSoloReport.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass([{ hidden: !hasSoloReport.value }, "strengths-container"])
                        }, [
                          _createVNode(StrengthsAndGapsList, {
                            ratings: _unref(user).strengthRatings,
                            "data-test": "solo-strengths-and-gaps-list"
                          }, null, 8, ["ratings"])
                        ], 2))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["href", "tooltip-text"])
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_16,
        (!!strengthData.value && !!currentDevelopPlan.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", null, [
                _createElementVNode("h4", _hoisted_18, " Developing: " + _toDisplayString(currentDevelopPlan.value.strengthItemDisplayTitle), 1),
                _createElementVNode("p", _hoisted_19, _toDisplayString(currentDevelopPlan.value.strengthItemShortDefinition), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("img", {
                  "data-test": "develop-image",
                  src: strengthData.value.data.strength_image.url,
                  alt: strengthData.value.data.strength_image.alt ?? 'Strength image'
                }, null, 8, _hoisted_21)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createBlock(LoadingPage, { key: 1 }))
}
}

})